/**
 * Importaciones necesarias para el la pagina de informes.
 */
import React, { useEffect, useState } from "react"; // Importa React y hooks.

import { timerFormat } from "../../helpers/helpers"; // funcion para formatear el tiempo
import useTranslation from "../../hooks/useTranslation";
import { Ic_rayo } from "../../helpers/ImagesCache";
/**
 * Componente principal que maneja la visualización de informes.
 *
 * @function HistoryText
 * @returns {JSX.Element} Un elemento que representa la interfaz de informes.
 */

const HistoryText = ({
  selectedReport,
  minimized,
  onChangeMinimized,
  monitorData,
}) => {
  const T = useTranslation();

  /**
   * Estado que indica si se está mostrando el informe completo.
   * @type {boolean}
   */
  const [isFullReport, setIsFullReport] = useState(minimized);

  /**
   * Estado que indica si se está mostrando el informe completo.
   * @type {boolean}
   */
  const [localHistory, setLocalHistory] = useState([]);

  /**
   * Alterna la visualización del informe completo.
   *
   * @function handlerFullReport
   */
  const handlerFullReport = () => {
    if (onChangeMinimized) {
      onChangeMinimized(!minimized);
    }
  };
  let startCase = false;
  useEffect(() => {
    const stopCase = selectedReport?.timeline?.history.filter(
      (item) => item.object == "stopCase"
    );
    const history = selectedReport?.timeline?.history.filter(
      (item) => item.object != "stopCase"
    );
    if (stopCase.length > 0) {
      setLocalHistory([...history, ...stopCase]);
    } else {
      setLocalHistory([...history]);
    }
  }, [selectedReport]);

  const getColors = (item) => {
    const isStart = item.object === "startCase";
    const isStop = item.object === "stopCase";
    const isDescarga =
      (item.object === "DEA" && item.title === "DESCARGA") ||
      item.object === "defibrillation";
    const isRythmEvaluation = item.object === "monitor";
    
    // Calculate if this rhythm evaluation event is over 2 minutes from case start
    const isRythmEvaluationOverTwoMinutes = isRythmEvaluation && 
      selectedReport?.timeline?.startCase && 
      (item.time - selectedReport.timeline.startCase) > 120000; // Two minutes in milliseconds

    if (isStart) {
      return { backgroundColor: "#2aac9c", color: "white", border: "none" };
    }
    if (isStop) {
      return { backgroundColor: "black", color: "white", border: "none" };
    }
    if (isDescarga) {
      return { backgroundColor: "#F1E818", color: "black", border: "none" };
    }
    if (isRythmEvaluation) {
      if (isRythmEvaluationOverTwoMinutes) {
        return { backgroundColor: "#D63B59", color: "white", border: "2px solid #D63B59" };
      } else {
        return { backgroundColor: "#EAF7F5", color: "#2aac9c", border: "2px solid #D63B59" };
      }
    }

    return { backgroundColor: "#EAF7F5", color: "#2aac9c", border: "none" };
  };

  const TimeLabel = ({ item }) => {
    const { backgroundColor, color, border } = getColors(item);

    const timeDiff = selectedReport?.timeline?.startCase
      ? item.time - selectedReport.timeline.startCase
      : null;

    const displayTime =
      timeDiff !== null && timeDiff >= 0
        ? timerFormat(new Date(timeDiff))
        : "--:--";

    return (
      <span
        className="text-sm font-[600] p-1 flex items-center rounded justify-center min-w-14"
        style={{ backgroundColor, color, border }}
      >
        {displayTime}
      </span>
    );
  };

  return (
    <>
      <div
        style={{ minHeight: "10vh" }}
        className="flex w-full flex-col mt-0 overflow-hidden overflow-y-hidden z-0"
      >
        {localHistory.map((item, index) => {
          if (item.object == "startCase") {
            startCase = true;
          }
          if (!item.hideOnReport) {
            return (
              <div
                key={"report-selected-" + index}
                className={` h-full w-full flex flex-col items-center `}
              >
                <div
                  className={`text-center flex  items-center gap-0 justify-between h-full w-full flex items-between`}
                >
                  <div className="text-sm text-left flex  p-1 justify-start items-center w-4/6 font-[500] gap-4">
                    <TimeLabel item={item} />
                    <div className="flex">
                      {
                        <span style={{ color: "#333233" }} className="text-xl">
                          {`${T(item.title)} ${
                            item.value ? T(item.value) : ""
                          }`}
                        </span>
                      }
                      {(item.title === "DESCARGA" ||
                        item.object === "defibrillation") && (
                        <img
                          src={Ic_rayo}
                          className="ml-[6px] h-[24px] w-[24px]"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          }
        })}
      </div>
      {/**
        <div className=' cursor-pointer w-full h-10 p-6 flex items-center justify-center text-2xl bg-[#0002]' onClick={handlerFullReport}>
                {
                    !minimized ? 
                    <div className='flex gap-10 items-center'>
                        <FontAwesomeIcon icon={faArrowUp} />
                        <span>Minimizar</span>
                        <FontAwesomeIcon icon={faArrowUp} />
                    </div>
                     :
                    <div className='flex gap-10 items-center'>
                        <FontAwesomeIcon icon={faArrowDown} /> 
                        <span>Mostrar todo</span>
                        <FontAwesomeIcon icon={faArrowDown} /> 
                    </div>
                }
        </div>
 * 
 */}
    </>
  );
};

export default HistoryText;
